'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}

const _=require('pulsar-utils/dist-es6/_');let

PseudoGroup=function(){
function PseudoGroup(){let{name='--',directPersons=[],children=[],parentGroupName:parentGroupName,parentGroupId:parentGroupId}=arguments.length>0&&arguments[0]!==void 0?arguments[0]:{};_classCallCheck(this,PseudoGroup);
this._name=name;
this._directPersons=directPersons;
this._children=children;
this._parentGroupName=parentGroupName;
this._parentGroupId=parentGroupId;

this._colSpan=1;
}_createClass(PseudoGroup,[{key:'name',get:function()

{
return this._name;
}},{key:'parentGroupName',get:function()

{
return this._parentGroupName;
}},{key:'parentGroupId',get:function()

{
return this._parentGroupId;
}},{key:'colSpan',get:function()

{
return this._colSpan;
},set:function(

colSpan){
this._colSpan=colSpan;
}},{key:'directPersons',get:function()

{
return this._directPersons;
}},{key:'children',get:function()

{
return this._children;
}}]);return PseudoGroup}();


module.exports=PseudoGroup;
//# sourceMappingURL=pseudoGroup.js.map
